import React, { useState } from 'react';
import { PlusIcon, MinusIcon } from 'lucide-react';
import { faqs } from '../data/content';
export function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="w-full bg-ink-800 px-4 py-14 sm:px-5 sm:py-20" data-id="element-54" data-mp="1blk84tb2asy0">
      <div className="mx-auto max-w-3xl" data-id="element-55" data-mp="1gjc3jxax0x6y">
        <h2 className="text-center text-xl font-extrabold uppercase text-white sm:text-3xl" data-id="element-56" data-mp="1gk5aay9vjmp3">
          ❓ Lo que más nos preguntan
        </h2>

        <ul className="mt-10 space-y-3" data-id="element-57" data-mp="28aru22flf42g">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <li key={faq.question} className="overflow-hidden rounded-2xl border border-white/10 bg-ink-900" data-id="element-58" data-mp="1uiv86g4ipqei" data-mpi={index}>
                <h3 data-id="element-59" data-mp="2n7imtsurhhj3">
                  <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} aria-controls={`faq-panel-${index}`} className="flex w-full items-center justify-between gap-4 px-5 py-5 text-left text-sm font-bold text-white transition-colors hover:text-brand-400 sm:px-6 sm:text-base" data-id="element-60" data-mp="2n70s50nqzbda">
                    {faq.question}
                    <span aria-hidden="true" className="text-brand-500" data-id="element-61" data-mp="19tvb9v02ncpr">
                      {isOpen ? <MinusIcon className="h-5 w-5" data-id="element-62" data-mp="1oii1wsv5fqwa" /> : <PlusIcon className="h-5 w-5" data-id="element-63" data-mp="1jkgfpz2ffbgl" />}
                    </span>
                  </button>
                </h3>
                {isOpen && <div id={`faq-panel-${index}`} className="border-t border-white/10 px-5 py-5 text-sm leading-relaxed text-gray-300 sm:px-6" data-id="element-64" data-mp="1skv6hdy5tirh">
                    {faq.answer}
                  </div>}
              </li>;
        })}
        </ul>
      </div>
    </section>;
}